var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatGiveaway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.66667 7.33333H18.3333C18.8396 7.33333 19.25 7.74374 19.25 8.25V10.0833C19.25 10.5896 18.8396 11 18.3333 11H3.66667C3.16041 11 2.75 10.5896 2.75 10.0833V8.25C2.75 7.74374 3.16041 7.33333 3.66667 7.33333Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 7.33333V19.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.4167 11V17.4167C17.4167 17.9029 17.2235 18.3692 16.8797 18.713C16.5359 19.0568 16.0696 19.25 15.5833 19.25H6.41667C5.93044 19.25 5.46412 19.0568 5.1203 18.713C4.77649 18.3692 4.58333 17.9029 4.58333 17.4167V11",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.875 7.33333C6.26721 7.33333 5.68432 7.09189 5.25455 6.66212C4.82478 6.23235 4.58333 5.64945 4.58333 5.04167C4.58333 4.43388 4.82478 3.85098 5.25455 3.42121C5.68432 2.99144 6.26721 2.75 6.875 2.75C7.7593 2.73459 8.62586 3.16365 9.36167 3.98123C10.0975 4.79881 10.6684 5.96695 11 7.33333C11.3316 5.96695 11.9025 4.79881 12.6383 3.98123C13.3741 3.16365 14.2407 2.73459 15.125 2.75C15.7328 2.75 16.3157 2.99144 16.7455 3.42121C17.1752 3.85098 17.4167 4.43388 17.4167 5.04167C17.4167 5.64945 17.1752 6.23235 16.7455 6.66212C16.3157 7.09189 15.7328 7.33333 15.125 7.33333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FD2D23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatGiveaway);
export default __webpack_public_path__ + "static/media/cat_giveaway.a380a6d45a7619616d84ad9505fa2936.svg";
export { ForwardRef as ReactComponent };